import { Box } from "@mui/material";
import InfoRow from "../blocks/InfoRowHeader";
import { useTranslation } from "react-i18next";

import { capitalizeWords, formatCnpj } from "../../../src/utilities/Utilities";
import { translateDbLabel } from "../../../src/utilities/translateDbLabel";

const AssignmentHeaderInfo = ({ headerInfo }) => {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language?.startsWith("en");
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
        gap: 4,
      }}
    >
      <Box>
        <InfoRow label={t("assing.processType")} value={capitalizeWords(translateDbLabel(headerInfo.process_description, isEnglish))} />
        <InfoRow label={t("assing.numberNfe")} value={headerInfo.number_nfe} />
      </Box>

      <Box>
        <InfoRow label={t("assing.emitterName")} value={capitalizeWords(headerInfo.name_supplier_)} />
        <InfoRow label={t("assing.emitterCnpj")} value={formatCnpj(headerInfo.supplier_cnpj)} />
      </Box>

      <Box>
        <InfoRow label={t("assing.nameDest")} value={capitalizeWords(headerInfo.recipient_name)} />
        <InfoRow label={t("assing.cnpjDest")} value={formatCnpj(headerInfo.recipient_cnpj)} />
      </Box>
    </Box>
  );
};

export default AssignmentHeaderInfo;